module.exports = __webpack_public_path__ + "575f08073aece5abf06fbaeb05c524cc.fbx";